import styled, { css } from 'styled-components';
import { Scalars } from '@bechtel/types';
import { Box, IconStyled, Heading } from '@bechtel/gds';
export const listWidth = '288px';
export const smallScreenListWidth = '240px';
export const collapsedListWidth = '32px';
interface PlanningListContainerStyledProps {
  isDrawerOpen: Scalars['Boolean'];
  isListCollapsed?: boolean;
}

interface ListContainerStyledProps {
  isListCollapsed?: boolean;
}

export const ListContainerStyled = styled.div<ListContainerStyledProps>`
  transition-duration: 160ms;
  transition-timing-function: ease-in-out;
  transition-property: width;
  height: 100vh;
  width: ${listWidth};

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    width: ${smallScreenListWidth};
  }
  ${({ isListCollapsed }) =>
    isListCollapsed &&
    css`
      width: ${collapsedListWidth} !important;
    `}
`;

export const PlanningListContainerStyled = styled.div<PlanningListContainerStyledProps>`
  height: 100%;
  width: 100%;
  visibility: ${({ isListCollapsed }) => (isListCollapsed ? 'hidden' : 'visible')};
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-direction: column;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 6px 10px 0 rgba(0, 0, 0, 0.14);
  color: ${({ theme }) => theme.colors.grey[1000]};

  &::before {
    box-shadow: 14px 0 12px -8px rgba(0, 0, 0, 0.1);
    content: '';
    height: 100%;
    pointer-events: none;
    position: absolute;
    left: calc(${listWidth} - 32px);
    width: 32px;
    /* Z-index required to show box shadow on top of drawer when the drawer is open as drawer has z-index of 1.  */
    ${(props) =>
      props.isDrawerOpen &&
      css`
        z-index: 2;
      `}
  }

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    /* width: ${smallScreenListWidth}; */
    &::before {
      left: calc(${smallScreenListWidth} - 32px);
    }
  }
`;
export const PlanningListCollapsedStyled = styled(Box)<ListContainerStyledProps>`
  visibility: ${({ isListCollapsed }) => (!isListCollapsed ? 'hidden' : 'visible')};
  background-color: ${({ theme }) => theme.colors.grey[100]};
  height: 100%;
  width: 100%;
`;

export const ExpandCollapseBorderBoxStyled = styled(Box)<ListContainerStyledProps>`
  position: absolute;
  top: 0;
  right: 0;
  width: 2px;
  height: 100%;
  z-index: 1; /* z-index needed to show the border all the way to the top*/
  transition-duration: 160ms;
  transition-timing-function: linear;
  transition-property: background-color;
  left: ${({ isListCollapsed }) => (!isListCollapsed ? smallScreenListWidth : collapsedListWidth)};

  ${({ theme }) => css`
    background-color: transparent;
    &:hover {
      background-color: ${theme.colors.blue[800]};
    }
  `};
`;

//TODO: Adding IconStyled caused this typescript error. Need to check alternative
export const ExpandCollapseBoxStyled = styled(Box)`
  cursor: pointer;
  position: absolute;
  top: 338px;
  left: -11px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;

  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    height: ${theme.spacings[600]};
    width: ${theme.spacings[600]};
    transition-duration: 160ms;
    transition-timing-function: ease-in-out;
    transition-property: color, background-color;
    &:hover {
      background-color: ${theme.colors.blue[800]};
      ${IconStyled} {
        color: ${theme.colors.white};
      }
    }
    ${ExpandCollapseBorderBoxStyled}:hover & {
      background-color: ${theme.colors.blue[800]};
      ${IconStyled} {
        color: ${theme.colors.white};
      }
    }
  `}
`;

export const ListSubHeadingStyled = styled(Heading)`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes[400]};
    background-color: ${theme.colors.grey[200]};
    padding-bottom: ${theme.spacings[500]};
    padding-left: ${theme.spacings[500]};
    padding-right: ${theme.spacings[500]};
    padding-top: ${theme.spacings[600]};
    color: ${theme.colors.grey[1000]};
    border-bottom: solid 1px ${theme.colors.grey[300]};
  `}
`;
